module.exports = __webpack_public_path__ + "img/news_new.36f66ee7.png";